import React, { useEffect } from 'react'
import LogoutLoadingScreen from '../components/ui/LogoutLoadingScreen';

const Logout = () => {
    const redirectUrl = process.env.REACT_APP_Auth_WEB_BASE_URL;

    useEffect(() => {
    const logoutHandler = async () => {
        const preferredLang = localStorage.getItem('preferredLang') || localStorage.getItem('i18nextLng') || localStorage.getItem('appLang');
        await localStorage.clear();
        if (preferredLang) {
            localStorage.setItem('preferredLang', preferredLang);
        }
        window.setTimeout(() => {
            window.location.replace(redirectUrl);
        }, 700);
    }

    logoutHandler();
    }, [redirectUrl]);

    return (
        <LogoutLoadingScreen />
    )
}

export default Logout
